// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Da0lLKbIvb_pQaxx73gH{padding:32px;border-radius:8px;border:1px solid var(--border-neutral-default)}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/rcs/ui/RcsInfo/RcsInfoForm/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,iBAAA,CACA,8CAAA","sourcesContent":[".container {\n  padding: 32px;\n  border-radius: 8px;\n  border: 1px solid var(--border-neutral-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Da0lLKbIvb_pQaxx73gH`
};
export default ___CSS_LOADER_EXPORT___;
